import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Col from "react-bootstrap/Col";
import "./TitleListPage.css";
import NotificationContainer from "../../components/NotificationContainer/NotificationContainer";
import TitleListContainer from "../../components/TitleListContainer/TitleListContainer";

class TitleListPage extends React.Component {
  render() {
    return (
      <Container>
        <Row>
          <Col>
            <Breadcrumb active="true" className="path_container">
              <Breadcrumb.Item href={process.env.REACT_APP_URL_ROOT}>
                Home
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        <Row>
          <Col>
            <TitleListContainer />
          </Col>
          <Col md="auto">
            <NotificationContainer />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default TitleListPage;
